import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

import ZOOMRESTAPIENDPOINTOPTIONS from "resources/img/zoom_rest_api_endpoint_options.png";
import ZOOMSERVERSDKAUTHENTICATIONFLOW from "resources/img/zoom_server_sdk_authentication_flow.png";
import ZOOMCOMPAT from "resources/img/zoom_compat_matrix.jpg";
import SERVER_ARCHITECTURE_AND_DATA_FLOW from "resources/img/zoom_server_architecture_and_data_flow.png";
import SERVER_DEDICATE_AND_CLOUD_ARCHITECTURE from "resources/img/zoom_server_dedicated_and_cloud_architecture.png";

export default React.createClass({
  displayName: "zoom-configuration-options",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container quick-guides-pages">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="compatibility">Compatibility of SDKs</h2>
                </div>
                <p>The FaceTec Device SDKs are compatible with the vast majority of devices in existence with a front-facing camera.  FaceTec SDKs are compatible with the vast majority of Windows, Mac, and Linux dev machines and production servers via Docker.  Please see the compatibility matrix below for more details.</p>
                <hr/>
              </section>

              <section id="FaceTec Browser SDK: Compatibility">
                <p style={{textAlign: "center"}}><img src={ZOOMCOMPAT}  width="100%" style={{maxWidth: '1300px'}} /></p>
                <p></p>
              </section>

              <SDKSidebar menuType="main" title="Configuration Options"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/compatibility.jsx